import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { EGamesId } from '@enums/common/games.enum';
import { faStar, faTimes } from '@fortawesome/free-solid-svg-icons';
import { BetService } from '@modules/games/bet.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ILottery } from 'src/app/interfaces/plays/play-bet.interface';
import { PlayLottery } from '../play-lottery';
import { DrawAPIService } from '@api/services/games/drawAPI.service';

@Component({
    selector: 'app-played-lottery',
    templateUrl: './played-lottery.component.html',
    styleUrls: ['./played-lottery.component.scss'],
    standalone: false
})
export class PlayedLotteryComponent implements OnInit, OnDestroy {

	public iconStar = faStar;
	public iconCross = faTimes;
	public totalBets: number;
	public reintegro: number;
	public gameNumbers: ILottery[] = [];
	public selectedNumbers: ILottery[] = [];
	public lastNumber: ILottery;
	public loading: boolean;
	public numTickets: number;
	public url: string;
	public lottery = [];
	public activeNumbers: number = 0;
	public desactivaAutomatico = false;

	private betSubscription: Subscription;
	private sorteoSub: Subscription;
	public numbers = []
	public pack = undefined
	public numbersShow: { number: string, count: number }[] = [];
	public image: string = '';
	public imageMult: string = '';

	private ticketsVisible = true;

	private serviceBets: any;

	public sorteo: any;

	@Input() gameId: EGamesId;
	@Input() manual: boolean;
	@Input() automatic: boolean;

	constructor(

		private betService: BetService,

	) {
	}

	ngOnInit() {
		this.betSubscription = this.betService.observableBets.pipe(
			map((response: any[]) => response.map(item => item.numero))
		).subscribe({
			next: (numbers: number[]) => {
				this.numbers = numbers;
				this.updateNumbersShow(numbers);
			},
			error: (e) => console.error(e),
			complete: () => console.info('complete')
		});

		this.sorteoSub = this.betService.sorteoObservable$.subscribe(res => {
			if (res) {
				this.sorteo = res;
				let miniatura = this.sorteo.miniaturas.find((miniatura: any) => miniatura.titulo.includes('mail'));
				let miniaturaMult = this.sorteo.miniaturas.find((miniatura: any) => miniatura.titulo.includes('decimo'));
				if (miniatura)
					this.image = "http://www.loteriaelnegrito.com/uploads/" + miniatura.path + miniatura.nombre;
				if (miniaturaMult)
					this.imageMult = "http://www.loteriaelnegrito.com/uploads/" + miniaturaMult.path + miniaturaMult.nombre;
			}
		});


		this.betService.observableBets.subscribe(bets => { // Remove it from the service
			this.serviceBets = bets;
		});

		this.betService.packObservable$.subscribe(pack => { // Remove it from the service
			this.pack = pack;
			// console.log(this.pack);
		});
	}

	deleteNumber(numberToDelete: number) {
		this.numbers = this.numbers.filter(number => number !== numberToDelete);
		this.updateNumbersShow(this.numbers); // Update numbersShow after deletion
		this.serviceBets = this.serviceBets.filter(bet => bet.numero !== numberToDelete);
		this.betService.setBets(this.serviceBets, 'played-lottery-1');
	}

	triggerChangeNumber() {
		this.betService.changeRandomTriggerFunction.emit();
	}

	updateNumbersShow(numbers: number[]) {
		const frequencyMap: { [key: number]: number } = {};
		numbers.forEach(number => {
			if (frequencyMap[number]) {
				frequencyMap[number]++;
			} else {
				frequencyMap[number] = 1;
			}
		});

		// Create a map of the current numbersShow for quick lookup
		const currentNumbersShowMap = new Map(this.numbersShow.map(item => [item.number, item]));

		// Update the frequency counts in place
		for (const [number, count] of Object.entries(frequencyMap)) {
			if (currentNumbersShowMap.has(number)) {
				currentNumbersShowMap.get(number).count = count;
			} else {
				this.numbersShow.push({ number, count });
			}
		}

		// Remove numbers that are no longer present
		this.numbersShow = this.numbersShow.filter(item => frequencyMap[item.number] !== undefined);
	}

	toggleTicketsVisibility() {
		this.ticketsVisible = !this.ticketsVisible;
	}

	get backgroundImage(): string {
		return this.image ? `url(${this.image})` : 'url(../../../../../../assets/images/background/empty_ticket.svg)';
	}
	get backgroundImageMult(): string {
		return this.imageMult ? `url(${this.imageMult})` : 'url(../../../../../../assets/images/background/empty_ticket.svg)';
	}

	ngOnDestroy(): void {
		this.betSubscription.unsubscribe();
		this.sorteoSub.unsubscribe();
	}
}
